// JoJo's Cookie Company - Order Builder JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // State Management
    const orderState = {
        boxSize: null,
        priceShip: 0,
        pricePickup: 0,
        selectedCookies: {},
        deliveryMethod: null,
        pickupLocation: null,
        pickupDate: null,
        pickupTime: null
    };
    
    // DOM Elements
    const step1 = document.getElementById('step1');
    const step2 = document.getElementById('step2');
    const step3 = document.getElementById('step3');
    
    const continueToFlavors = document.getElementById('continueToFlavors');
    const continueToDelivery = document.getElementById('continueToDelivery');
    const backToSize = document.getElementById('backToSize');
    const backToFlavors = document.getElementById('backToFlavors');
    const proceedToCheckout = document.getElementById('proceedToCheckout');
    
    const selectedCount = document.getElementById('selectedCount');
    const totalCount = document.getElementById('totalCount');
    
    const summaryBoxSize = document.getElementById('summaryBoxSize');
    const summaryDelivery = document.getElementById('summaryDelivery');
    const summaryCookies = document.getElementById('summaryCookies');
    const summarySubtotal = document.getElementById('summarySubtotal');
    const summaryTotal = document.getElementById('summaryTotal');
    const shippingInfo = document.getElementById('shippingInfo');
    const shippingPrice = document.getElementById('shippingPrice');
    const pickupPrice = document.getElementById('pickupPrice');
    const pickupDetails = document.getElementById('pickupDetails');
    
    // Progress Steps
    const progressSteps = document.querySelectorAll('.progress-steps .step');
    
    function updateProgressStep(stepNum) {
        progressSteps.forEach(step => {
            const stepNumber = parseInt(step.dataset.step);
            if (stepNumber <= stepNum) {
                step.classList.add('active');
            } else {
                step.classList.remove('active');
            }
        });
    }
    
    // Step 1: Box Size Selection
    const boxSizeInputs = document.querySelectorAll('input[name="boxSize"]');
    boxSizeInputs.forEach(input => {
        input.addEventListener('change', function() {
            orderState.boxSize = parseInt(this.value);
            orderState.priceShip = parseFloat(this.dataset.priceShip);
            orderState.pricePickup = parseFloat(this.dataset.pricePickup);
            
            totalCount.textContent = orderState.boxSize;
            continueToFlavors.disabled = false;
            
            // Update summary
            summaryBoxSize.textContent = `${orderState.boxSize} cookies`;
            
            // Update pricing in delivery step
            shippingPrice.textContent = `$${orderState.priceShip.toFixed(2)}`;
            pickupPrice.textContent = `$${orderState.pricePickup.toFixed(2)}`;
            
            updateSummary();
        });
    });
    
    continueToFlavors.addEventListener('click', function() {
        step1.classList.add('hidden');
        step2.classList.remove('hidden');
        updateProgressStep(2);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    // Step 2: Cookie Selection
    const cookieCards = document.querySelectorAll('.cookie-select-card');
    
    cookieCards.forEach(card => {
        const selectBtn = card.querySelector('.select-btn');
        const cookieId = card.dataset.cookie;
        const countSpan = selectBtn.querySelector('.count');
        
        selectBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            
            // Initialize if not exists
            if (!orderState.selectedCookies[cookieId]) {
                orderState.selectedCookies[cookieId] = {
                    name: card.querySelector('h4').textContent,
                    count: 0
                };
            }
            
            // Increment count
            const currentTotal = getTotalSelectedCookies();
            
            if (currentTotal < orderState.boxSize) {
                orderState.selectedCookies[cookieId].count++;
                countSpan.textContent = orderState.selectedCookies[cookieId].count;
                card.classList.add('selected');
                updateCookieSelection();
            } else {
                // Show error if trying to add more than box size
                alert(`You can only select ${orderState.boxSize} cookies. Remove a cookie to add another.`);
            }
        });
        
        // Click on card also selects
        card.addEventListener('click', function() {
            selectBtn.click();
        });
        
        // Right click or long press to decrease
        card.addEventListener('contextmenu', function(e) {
            e.preventDefault();
            decreaseCookie(cookieId, card, countSpan);
        });
        
        // Add minus button functionality
        selectBtn.addEventListener('dblclick', function(e) {
            e.stopPropagation();
            decreaseCookie(cookieId, card, countSpan);
        });
    });
    
    function decreaseCookie(cookieId, card, countSpan) {
        if (orderState.selectedCookies[cookieId] && orderState.selectedCookies[cookieId].count > 0) {
            orderState.selectedCookies[cookieId].count--;
            countSpan.textContent = orderState.selectedCookies[cookieId].count;
            
            if (orderState.selectedCookies[cookieId].count === 0) {
                card.classList.remove('selected');
                delete orderState.selectedCookies[cookieId];
            }
            
            updateCookieSelection();
        }
    }
    
    function getTotalSelectedCookies() {
        return Object.values(orderState.selectedCookies).reduce((sum, cookie) => sum + cookie.count, 0);
    }
    
    function updateCookieSelection() {
        const total = getTotalSelectedCookies();
        selectedCount.textContent = total;
        
        // Enable continue button if selection matches box size
        continueToDelivery.disabled = total !== orderState.boxSize;
        
        // Update summary
        updateSummary();
    }
    
    backToSize.addEventListener('click', function() {
        step2.classList.add('hidden');
        step1.classList.remove('hidden');
        updateProgressStep(1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    continueToDelivery.addEventListener('click', function() {
        step2.classList.add('hidden');
        step3.classList.remove('hidden');
        updateProgressStep(3);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    // Step 3: Delivery Method
    const deliveryInputs = document.querySelectorAll('input[name="delivery"]');
    deliveryInputs.forEach(input => {
        input.addEventListener('change', function() {
            orderState.deliveryMethod = this.value;
            
            if (this.value === 'pickup') {
                pickupDetails.classList.remove('hidden');
                summaryDelivery.textContent = 'Local Pickup';
                shippingInfo.classList.add('hidden');
            } else {
                pickupDetails.classList.add('hidden');
                summaryDelivery.textContent = 'Shipping';
                shippingInfo.classList.remove('hidden');
            }
            
            updateSummary();
            checkStep3Complete();
        });
    });
    
    // Pickup details
    const pickupLocation = document.getElementById('pickupLocation');
    const pickupDate = document.getElementById('pickupDate');
    const pickupTime = document.getElementById('pickupTime');
    
    if (pickupLocation) {
        pickupLocation.addEventListener('change', function() {
            orderState.pickupLocation = this.value;
            checkStep3Complete();
        });
    }
    
    if (pickupDate) {
        // Set min date to tomorrow
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        pickupDate.min = tomorrow.toISOString().split('T')[0];
        
        pickupDate.addEventListener('change', function() {
            orderState.pickupDate = this.value;
            checkStep3Complete();
        });
    }
    
    if (pickupTime) {
        pickupTime.addEventListener('change', function() {
            orderState.pickupTime = this.value;
            checkStep3Complete();
        });
    }
    
    function checkStep3Complete() {
        if (orderState.deliveryMethod === 'shipping') {
            proceedToCheckout.disabled = false;
        } else if (orderState.deliveryMethod === 'pickup') {
            proceedToCheckout.disabled = !(
                orderState.pickupLocation &&
                orderState.pickupDate &&
                orderState.pickupTime
            );
        }
    }
    
    backToFlavors.addEventListener('click', function() {
        step3.classList.add('hidden');
        step2.classList.remove('hidden');
        updateProgressStep(2);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    proceedToCheckout.addEventListener('click', function() {
        // Here you would integrate with Shopify checkout
        // For now, show the order details
        const orderDetails = {
            boxSize: orderState.boxSize,
            cookies: orderState.selectedCookies,
            delivery: orderState.deliveryMethod,
            location: orderState.pickupLocation,
            date: orderState.pickupDate,
            time: orderState.pickupTime,
            total: calculateTotal()
        };
        
        console.log('Order Details:', orderDetails);
        
        // In Shopify integration, you would:
        // 1. Create cart with selected cookies
        // 2. Add delivery method as note/attribute
        // 3. Redirect to checkout
        
        alert('Order ready! This would redirect to Shopify checkout.\n\nTotal: $' + calculateTotal().toFixed(2));
        
        // Example Shopify integration:
        // window.location.href = '/cart?add[items][][id]=VARIANT_ID&add[items][][quantity]=1';
    });
    
    // Update Summary
    function updateSummary() {
        // Update cookies list
        const cookiesList = Object.entries(orderState.selectedCookies)
            .filter(([_, data]) => data.count > 0)
            .map(([id, data]) => `
                <li>
                    <span>${data.name}</span>
                    <span>×${data.count}</span>
                </li>
            `).join('');
        
        if (cookiesList) {
            summaryCookies.innerHTML = `<ul>${cookiesList}</ul>`;
        } else {
            summaryCookies.innerHTML = '<p class="empty-state">No cookies selected yet</p>';
        }
        
        // Update totals
        const subtotal = orderState.deliveryMethod === 'pickup' ? orderState.pricePickup : orderState.priceShip;
        const shipping = orderState.deliveryMethod === 'shipping' ? 10.50 : 0;
        const total = calculateTotal();
        
        summarySubtotal.textContent = `$${subtotal.toFixed(2)}`;
        summaryTotal.textContent = `$${total.toFixed(2)}`;
    }
    
    function calculateTotal() {
        if (!orderState.boxSize) return 0;
        
        const subtotal = orderState.deliveryMethod === 'pickup' ? orderState.pricePickup : orderState.priceShip;
        const shipping = orderState.deliveryMethod === 'shipping' ? 10.50 : 0;
        
        return subtotal + shipping;
    }
    
    // Mobile Menu Toggle (same as homepage)
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const navMenu = document.querySelector('.nav-menu');
    
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            navMenu.classList.toggle('active');
        });
    }
});
